var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 2.08203C6.76009 2.08203 2.08301 6.75911 2.08301 12.4987C2.08301 18.2383 6.76009 22.9154 12.4997 22.9154C18.2393 22.9154 22.9163 18.2383 22.9163 12.4987C22.9163 6.75911 18.2393 2.08203 12.4997 2.08203ZM15.9997 14.8945C16.3018 15.1966 16.3018 15.6966 15.9997 15.9987C15.8434 16.1549 15.6455 16.2279 15.4476 16.2279C15.2497 16.2279 15.0518 16.1549 14.8955 15.9987L12.4997 13.6029L10.1038 15.9987C9.94759 16.1549 9.74968 16.2279 9.55176 16.2279C9.35384 16.2279 9.15593 16.1549 8.99968 15.9987C8.69759 15.6966 8.69759 15.1966 8.99968 14.8945L11.3955 12.4987L8.99968 10.1029C8.69759 9.80078 8.69759 9.30078 8.99968 8.9987C9.30176 8.69662 9.80176 8.69662 10.1038 8.9987L12.4997 11.3945L14.8955 8.9987C15.1976 8.69662 15.6976 8.69662 15.9997 8.9987C16.3018 9.30078 16.3018 9.80078 15.9997 10.1029L13.6038 12.4987L15.9997 14.8945Z",
    fill: "#BE1F2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsCloseCircle);
export default __webpack_public_path__ + "static/media/ads-close-circle.334fa340b9e35679d3171bbf29c94ee0.svg";
export { ForwardRef as ReactComponent };